const DOCUMENTS_BASE_PATH = "/documents/AccumulatorInstructions";

// Matriz de negocio: rango + caja + código del acumulador = documento.
// Los códigos se normalizan al resolverlos para tolerar diferencias de formato
// procedentes del servicio (mayúsculas, acentos, puntos, guiones o espacios).
export const accumulatorInstructions = [
  {
    temperatureRange: 1,
    box: "smallBox",
    code: "RFP900",
    accumulator: "CONG_Tempack_P/M",
    file: "01. ALIMENTACIÓN CONGELADO PEQUEÑA DSX21 (Rev. 19-06-26).pdf",
  },
  {
    temperatureRange: 1,
    box: "mediumBox",
    code: "RFP900",
    accumulator: "CONG_Tempack_P/M",
    file: "02. ALIMENTACIÓN CONGELADO MEDIANA DSX40 (Rev. 19-06-26).pdf",
  },
  {
    temperatureRange: 1,
    box: "mediumPlusBox",
    code: "AC480_C21B",
    accumulator: "CONG_SCB_M/G",
    file: "03. ALIMENTACIÓN CONGELADO MEDIANA SCB480 (Rev. 19-06-26).pdf",
  },
  {
    temperatureRange: 1,
    box: "largeBox",
    code: "EPF4100",
    accumulator: "CONG_Tempack_Maxi",
    file: "04. ALIMENTACIÓN CONGELADO GRANDE CT77 (EPR 4100) (Rev. 19-06-26).pdf",
  },
  {
    temperatureRange: 1,
    box: "largeBox",
    code: "RFP2000",
    accumulator: "CONG_Tempack_G",
    file: "05. ALIMENTACIÓN CONGELADO GRANDE CT77 (RFP 2000) (Rev. 19-06-26).pdf",
  },
  {
    temperatureRange: 1,
    box: "largeBox",
    code: "AC480_C21B",
    accumulator: "CONG_SCB_M/G",
    file: "06. ALIMENTACIÓN CONGELADO GRANDE CT77 (SCB) (Rev. 19-06-26).pdf",
  },
  {
    temperatureRange: 2,
    box: "smallBox",
    code: "RCP900",
    accumulator: "FRIO_Tempack_P/M",
    file: "07. ALIMENTACIÓN REFRIGERADO PEQUEÑA DSX21 (Rev. 19-06-26).pdf",
  },
  {
    temperatureRange: 2,
    box: "mediumBox",
    code: "RCP900",
    accumulator: "FRIO_Tempack_P/M",
    file: "08. ALIMENTACIÓN REFRIGERADO MEDIANA DSX40 (Rev. 19-06-26).pdf",
  },
  {
    temperatureRange: 2,
    box: "mediumPlusBox",
    code: "AC480_F5N",
    accumulator: "FRIO_SCB_M/G_TapNegro",
    file: "09. ALIMENTACIÓN REFRIGERADO MEDIANA SCB480 - tapón negro (Rev. 19-06-26).pdf",
  },
  {
    temperatureRange: 2,
    box: "mediumPlusBox",
    code: "AC480_F1G",
    accumulator: "FRIO_SCB_M/G_TapVerde",
    file: "10. ALIMENTACIÓN REFRIGERADO MEDIANA SCB480 - Tapón verde (Rev. 19-06-26).pdf",
  },
  {
    temperatureRange: 2,
    box: "largeBox",
    code: "EPR4100",
    accumulator: "FRIO_Tempack_Maxi",
    file: "11. ALIMENTACIÓN REFRIGERADO CT77 (EPR 4100) (Rev. 19-06-26).pdf",
  },
  {
    temperatureRange: 2,
    box: "largeBox",
    code: "AC480_F5N",
    accumulator: "FRIO_SCB_M/G_TapNegro",
    file: "12. ALIMENTACIÓN REFRIGERADO GRANDE CT77 (SCB) - Tapón negro (Rev. 19-06-26).pdf",
  },
  {
    temperatureRange: 2,
    box: "largeBox",
    code: "AC480_F1G",
    accumulator: "FRIO_SCB_M/G_TapVerde",
    file: "13. ALIMENTACIÓN REFRIGERADO GRANDE CT77 (SCB) - Tapón verde (Rev. 19-06-26).pdf",
  },
];

export function normalizeAccumulatorName(value = "") {
  return String(value || "")
    .replace(/[áàäâ]/gi, "a")
    .replace(/[éèëê]/gi, "e")
    .replace(/[íìïî]/gi, "i")
    .replace(/[óòöô]/gi, "o")
    .replace(/[úùüû]/gi, "u")
    .replace(/ñ/gi, "n")
    .replace(/[^a-zA-Z0-9]/g, "")
    .toLowerCase();
}

export function getTemperatureRangeId(value) {
  const rawValue = value?.key ?? value;
  const numericValue = Number(rawValue);

  if ([1, 2, 3].includes(numericValue)) return numericValue;

  const normalizedValue = normalizeAccumulatorName(rawValue);
  const rangeLabels = {
    congelado: 1,
    "20c": 1,
    refrigerado: 2,
    entre2cy8c: 2,
    ambiente: 3,
    entre15cy25c: 3,
  };

  return rangeLabels[normalizedValue] || null;
}

export function getAccumulatorInstruction(
  temperatureRange,
  box,
  accumulatorCode,
) {
  const rangeId = getTemperatureRangeId(temperatureRange);
  const normalizedCode = normalizeAccumulatorName(accumulatorCode);

  if (!rangeId || !box || !normalizedCode) return null;

  const instruction = accumulatorInstructions.find(
    (item) =>
      item.temperatureRange === rangeId &&
      item.box === box &&
      normalizeAccumulatorName(item.code) === normalizedCode,
  );

  if (!instruction) return null;

  return {
    ...instruction,
    url: `${process.env.PUBLIC_URL || ""}${DOCUMENTS_BASE_PATH}/${encodeURIComponent(
      instruction.file,
    )}`,
  };
}
